<div class="dialogue-content">
    <div class="mat-dialogue-header">

        <h4 class="mat-dialog-title text-center text-white mb-4">
            Let's Update User Details
        </h4>
    </div>
    <form [formGroup]="userForm" (ngSubmit)="submitUserForm()">
        <mat-dialog-content class="p-0">
            <div class="text-left w-100">

                <div class="row gy-3 m-0">
                    <div class="col-lg-12">
                        <div class="user-profile position-relative m-auto d-table">
                            <img [src]="imageSrc || 'assets/images/default-user-profile.svg'"
                                style="width: 100px; border-radius: 70px;height: 100px;" class=" user-img" />

                            <label for="upload-btn" class="user-profile-btn position-set">
                                <img src="assets/images/camera.svg" />
                            </label>
                            <!-- Cross icon -->
                            <button *ngIf="imageSrc" type="button" class="remove-btn" (click)="removeImage()" title="Remove Profile Picture">✖</button>
                            <input type="file" id="upload-btn" accept=".jpg, .jpeg, .png"
                                (change)="onFileSelected($event)" hidden />
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <label>First Name<span class="text-danger">*</span></label>
                        <mat-form-field class="w-100">
                            <input type="text" matInput formControlName="firstName"
                                oninput="this.value = this.value.replace(/[^A-Za-z\s]/g, '').replace(/^\s+/g, '')"
                                maxlength="100" placeholder="First name" />
                        </mat-form-field>
                        <mat-error *ngIf="submitted && userFormControls['firstName'].hasError('required')">
                             First name is required. 
                        </mat-error>
                    </div>
                    <div class="col-lg-12">
                        <label>Last Name<span class="text-danger">*</span></label>
                        <mat-form-field class="w-100">
                            <input type="text" matInput formControlName="lastName"
                                oninput="this.value = this.value.replace(/[^A-Za-z\s]/g, '').replace(/^\s+/g, '')"
                                maxlength="100" placeholder="Last name" />
                        </mat-form-field>
                        <mat-error *ngIf="submitted && userFormControls['lastName'].hasError('required')"> 
                            Last name is required. 
                        </mat-error>
                    </div>
                    <div class="col-lg-12">
                        <label>Email Address<span class="text-danger">*</span></label>
                        <mat-form-field class="w-100">
                            <input type="text" matInput formControlName="userEmail"
                                oninput="this.value = this.value.replace(/^\s+/g, '')" maxlength="250"
                                placeholder="Email" />
                        </mat-form-field>
                        <mat-error *ngIf="submitted && userFormControls['userEmail'].hasError('required')">
                            Email is required.
                        </mat-error> 
                        <mat-error *ngIf="submitted && userFormControls['userEmail'].hasError('pattern')"> 
                            Email is not valid. 
                        </mat-error>
                    </div>

                    <div class="col-lg-12">
                        <label>Phone Number</label>
                        <mat-form-field class="w-100">
                            <input type="text" matInput formControlName="phone"
                                oninput="this.value = this.value.trimStart().replace(/\D/g, '').substring(0, 12)"
                                placeholder="Phone number" />
                        </mat-form-field>
                        <mat-error *ngIf="submitted && userForm.get('phone')?.hasError('minlength')"> 
                            Phone no. must be 12 numbers. 
                        </mat-error>
                    </div>
                    <div class="col-lg-12">
                        <label>Address</label>
                        <mat-form-field class="w-100">
                            <input type="text" matInput formControlName="address"
                                oninput="this.value = this.value.replace(/^\s+/g, '')" maxlength="250"
                                placeholder="Address" />
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions
            class="dialog-actions gap-3 pt-4 p-0 d-flex flex-xl-nowrap flex-wrap  justify-content-center">
            <button matButton="filled" type="button" class="dialog-btn-secondary" mat-dialog-close
                (click)="close()">Cancel</button>
            <button matButton="filled" type="submit" class="dialog-btn-primary">Update</button>
        </mat-dialog-actions>
    </form>
</div>